let savedValues = {}; // Object to store input values
let tries = 0; // Counter for attempts to update slider position
let savedScrollPosition = 0; // Store scroll position when modal opens

function openPopup() {
    const overlay = document.getElementById("quote-form-popup-overlay");
    const container = document.getElementById("quote-form-container");
    const body = document.querySelector('body');

    // Save current scroll position
    savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    body.classList.add('quote-form-open');
    // Set top position to maintain scroll position
    body.style.top = `-${savedScrollPosition}px`;
    
    overlay.style.display = "flex";
    container.style.display = "block";

    // Wait a moment to ensure sliders are visible before initializing
    document.querySelectorAll(".quote-form-slider").forEach((slider) => {
        slider.addEventListener("touchstart", function (event) {
            event.preventDefault();
        }, { passive: false });

        slider.addEventListener("touchmove", function (event) {
            event.preventDefault();
            let touch = event.touches[0];
            let rect = slider.getBoundingClientRect();
            let percent = (touch.clientX - rect.left) / rect.width;
            let value = Math.round(percent * (slider.max - slider.min) + parseInt(slider.min));

            // Ensure value stays within range
            value = Math.max(slider.min, Math.min(slider.max, value));
            slider.value = value;

            updateValue(slider);
        }, { passive: false });

        // Update all slider positions on load
        updateValue(slider);
    });
}





function closePopup() {
    const overlay = document.getElementById("quote-form-popup-overlay");
    const body = document.querySelector('body');
    
    overlay.style.display = "none";
    document.getElementById("quote-form-container").style.display = "none";
    body.classList.remove('quote-form-open');
    
    // Restore scroll position
    body.style.top = '';
    window.scrollTo(0, savedScrollPosition);
    
    savedValues = {};
    formData = {};
    nextStep(1);

}



function updateValue(slider) {
    const valueDisplay = slider.closest(".slider-quote-form-container").querySelector(".quote-form-value-display-input");

    // Update input field value
    valueDisplay.value = slider.value;

    requestAnimationFrame(() => {
        const sliderRect = slider.getBoundingClientRect();
        if (sliderRect.width === 0) {
            console.warn("Slider width is still 0, delaying execution...");
            if (tries < 50) {
                setTimeout(() => updateValue(slider), 50);
                tries++;
            }
            return;
        }

        // Calculate the thumb position dynamically
        const thumbPosition = ((slider.value - slider.min) / (slider.max - slider.min)) * sliderRect.width;
        valueDisplay.parentNode.style.left = `${thumbPosition}px`;
    });
}

// Function to update slider position when input value is changed manually
function updateSliderFromInput(input) {
    const slider = input.closest(".slider-quote-form-container").querySelector(".quote-form-slider");
    let min = parseInt(input.min);
    let max = parseInt(input.max);
    let value = parseInt(input.value);

    if (isNaN(value)) return; // Ignore empty input

    value = Math.max(min, Math.min(max, value)); // Keep value within range

    slider.value = value;
    updateValue(slider);
}




// Ensure position is set correctly for all sliders on page load
window.addEventListener("load", function () {
    document.querySelectorAll(".quote-form-slider").forEach((slider) => {
        setTimeout(() => updateValue(slider), 50);

        // Attach event listener for real-time updates
        slider.addEventListener("input", function () {
            tries = 0;
            updateValue(slider);
        });

        // Fix for mobile: Add touch event listeners
        slider.addEventListener("touchstart", function () {
            tries = 0;
            updateValue(slider);
        });

        slider.addEventListener("touchmove", function () {
            tries = 0;
            updateValue(slider);
        });

        slider.addEventListener("touchend", function () {
            tries = 0;
            updateValue(slider);
        });
    });
    const ctaBtn = document.querySelector(".button--get-custom-quote");
    console.log(ctaBtn);
    if (!!ctaBtn) {
        console.log("Hooking into custom quote CTA button.");
        ctaBtn.addEventListener("click", (event) => {
            openPopup();
        });
    }
});



let formData = {}; // Object to store step-wise input values

function saveStepData(step) {
    let stepElement = document.getElementById('quote-form-step' + step);
    let inputs = stepElement.querySelectorAll('input');

    inputs.forEach(input => {
        if (input.type === 'radio' && input.checked) {
            formData[input.name] = input.value; // Store selected radio button
        } else if (input.type === 'range') {
            formData[input.name] = input.value; // Store slider value
        }
    });
    let external_fields = document.getElementById('external_fields');
    if (external_fields !== undefined) {
        document.getElementById("external_fields").value = JSON.stringify(formData);
    }



    console.log(formData);
}

function restoreStepData(step) {
    let stepElement = document.getElementById('quote-form-step' + step);
    let inputs = stepElement.querySelectorAll('input');

    inputs.forEach(input => {
        if (formData[input.name] !== undefined) {
            if (input.type === 'radio' && input.id === formData[input.name]) {
                input.checked = true; // Restore selected radio button
            } else if (input.type === 'range') {
                input.value = formData[input.name]; // Restore slider value
                updateValue(input, input.nextElementSibling.id); // Update display
            }
        }
    });
}

const lastFormStepClassName = 'quote-form-upload-step';

function nextStep(step) {
    let activeStep = document.querySelector('.quote-form-step.active');
    let currentStep = parseInt(activeStep.id.replace('quote-form-step', ''), 10);

    saveStepData(currentStep); // Save data before switching step

    document.querySelectorAll('.quote-form-step').forEach(el => el.classList.remove('active'));
    let nextStepPage = document.getElementById('quote-form-step' + step);
    nextStepPage.classList.add('active');

    restoreStepData(step); // Restore data when coming back

    // Update file loader
    if (nextStepPage.classList.contains(lastFormStepClassName)) {
        configureFileUploadBox();

        configureFormSubmitAction();
    }
}

function selectOption(button) {
    document.querySelectorAll('.quote-form-option-buttons button').forEach(btn => btn.classList.remove('selected'));
    button.classList.add('selected');
}

const submitButtonSelector = 'button[name="submit-btn"]';
const quoteFormInnerWrapperSelector = `.${lastFormStepClassName} .quote-form-yes-no-buttons`;
const quoteFormSubmittingImageSelector = '.quote-form-submitting-image';

function waitForDiv(selector, callback) {
    const element = document.querySelector(selector);
    if (element && element.style.display !== "none") {
        // Element is visible, execute the callback
        callback(element);
    } else {
        setTimeout(() => waitForDiv(selector, callback), 100);
    }
}

function showSubmittingAnimation() {
    console.log("Adding submitting animation...");
    let formStepWrapper = document.querySelector('.' + lastFormStepClassName );
    if (formStepWrapper) {
        let formContainer = formStepWrapper.parentNode;
        if (formContainer) {
            formContainer.classList.add("submitting");
        }
        const submitImage = document.querySelector(quoteFormSubmittingImageSelector);
        if (submitImage) {
            submitImage.style.display = "flex";
        }

    }
}
 

function configureFormSubmitAction() {
    let btn = document.querySelector(submitButtonSelector);
    if (btn) {
        console.log("Hooking into submit button behavior: ", btn);
        btn.addEventListener("click", (event) => {
            //event.preventDefault(); 
            console.log("Performing initial form validation...");
            let form = document.querySelector('.cp24_user_reg_form');
            if (form && !!Validate) {
                if (Validate(form) != 0) {
                    console.log("Could not validate form. Skipping submitting.");
                    return;
                }
                // For some reason preventDefault() is needed in this case
                if (!$(form).valid()) {
                    console.log("Could not validate form with jQuery. Skipping submitting.");
                    event.preventDefault(); 
                    return;
                }
            } else {
                console.log("Could not find form or validate function. Skipping submitting.");
                return;
            }

            // Remove dashes from phone number
            const phoneInput = document.querySelector('#phone-number');
            if (phoneInput) {
                let phoneNumber = phoneInput.value.replace(/-/g, '');
                phoneInput.value = phoneNumber;
            }
            console.log("Phone number formatted: " + phoneInput.value);
                  
            console.log("Adding submitting animation...");
            showSubmittingAnimation();

            console.log("Adding error handling...");
             
            waitForDiv('.cp24_message_error', (element) => {
                // Code to execute when the div is visible
                console.log('An error ocurred...');
                let formStepWrapper = document.querySelector('.' + lastFormStepClassName );
                if (formStepWrapper) {
                    let formContainer = formStepWrapper.parentNode;
                    if (formContainer) {
                        formContainer.classList.remove("submitting");
                    }
                }

            });
        });
    }
}

let uploadBoxConfigured = false;
const uploadBoxSelector = '.fb-file';
const fileInputSelector = '#file-1740453889722';
const fileInputLabelSelector = `label[for='${fileInputSelector.substring(1)}']`;
const successMessageSelector = '.cp24contentsuccess';


function updateUploadBoxContent(fileInput) {
    let label = document.querySelector(fileInputLabelSelector);
    if (fileInput.files.length == 1) {
        label.textContent = fileInput.files[0].name;
    } else if (fileInput.files.length > 1) {
        label.textContent = fileInput.files.length + " files selected.";
    } else {
        label.innerHTML = "Upload Files<br />(Drag and drop files here)";
    }
    console.log("Updated file upload box content: " + label.textContent);
}

function configureFileUploadBox() {
    if (!uploadBoxConfigured) {
        uploadBoxConfigured = true;
        const uploadBox = document.querySelector(uploadBoxSelector);
        const fileInput = document.querySelector(fileInputSelector);

        fileInput.setAttribute('multiple','1') // allow multi select
        // Open file picker when clicking on the box
        if (uploadBox) {
            //uploadBox.addEventListener("click", () => fileInput.click());

            updateUploadBoxContent(fileInput);
            fileInput.addEventListener("change", function() {
                updateUploadBoxContent(this);
            });

            // Drag & drop functionality
            uploadBox.addEventListener("dragover", (event) => {
                event.preventDefault();
                uploadBox.classList.add("dragover");
            });

            uploadBox.addEventListener("dragleave", () => {
                uploadBox.classList.remove("dragover");
            });

            uploadBox.addEventListener("drop", (event) => {
                event.preventDefault();
                uploadBox.classList.remove("dragover");
                fileInput.files = event.dataTransfer.files;
                //alert(fileInput.files.length + " file(s) selected");
            });
        }
        console.log("File upload step configured.");
    }

    // Configure submitting message
    // Hide this now since lottie needed to be display:flex to load properly.
    const submitImage = document.querySelector(quoteFormSubmittingImageSelector);
    if (submitImage) {
        submitImage.style.display = "none";
    }

    /*
    // Configure success message
    const successMessage = document.querySelector(successMessageSelector);
    if (successMessage) {
        successMessage.innerHTML = "Thank you!<br />You will hear back from us in your email shortly."
    }
    */
}


/* Format phone number */
window.addEventListener('load', () => {
  const phoneInput = document.querySelector('#phone-number');
  phoneInput.addEventListener('keydown', disallowNonNumericInput);
  phoneInput.addEventListener('keyup', formatToPhone);
});
  
const disallowNonNumericInput = (evt) => {
  if (evt.ctrlKey) { return; }
  if (!!evt.key && evt.key.length > 1) { return; }
  if (/[0-9.]/.test(evt.key)) { return; }
  evt.preventDefault();
}

const formatToPhone = (evt) => {
  const digits = evt.target.value.replace(/\D/g,'').substring(0,10);
  const areaCode = digits.substring(0,3);
  const prefix = digits.substring(3,6);
  const suffix = digits.substring(6,10);

  if (!digits) { return; }
  if(digits.length > 6) {evt.target.value = `${areaCode}-${prefix}-${suffix}`;}
  else if(digits.length > 3) {evt.target.value = `${areaCode}-${prefix}`;}
  else if(digits.length > 0) {evt.target.value = `${areaCode}`;}
};
